module.exports = __webpack_public_path__ + "img/banner03_gearingupthetrade-e.da765b1c.jpg";